// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","content-wrapper":"Footer_content-wrapper__ru8Y1","logo":"Footer_logo__+JiYo","social":"Footer_social__iB1oi","copyright":"Footer_copyright__JQMtz"};